<app-page-meta pageTitle="finzy - Preferences"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
  <div class="row">
    <app-investormenu></app-investormenu>
    <div class="col-xs-12 col-md-10 col-lg-11 main-content">
      <div class="col-md-8 col-md-offset-2">
        <h1 class="heading">Investment Preferences</h1>
        <div class="preferences-content">
          <div *ngIf="!shouldShowDataLoader">
            <div class="d-flex">
              <h2 class="small-heading">finzyPRO+ Master Rating Preference</h2>
              <div class="d-flex justify-content-end" style="flex-grow: 1; margin-bottom: 10px;">
                <a (click)="onKnowMoreAboutFinzyProMasterPreferencesClicked()" class="align-self-end">Know more</a>
              </div>
            </div>
            <p class="preferences-description">
              You can choose your preferred loan rating categories below. This master preference will be
              used to find loans for any ReinvestPRO and finzyBolt portfolios that are created. This will
              also be the default selection to find loans for finzyPRO+ portfolios but can be changed at a
              portfolio level while creating every finzyPRO+ portfolio.<br />
              Your customisation will be applied to portfolios that are created after you save your
              preference here.
            </p>
            <mat-card>
              <mat-card-content class="pb-0 pb-md-5">
                <mat-card class="no-border mb-0 pb-0">
                  <mat-card-title>
                    <p class="card-heading">Interest Rate & Risk Range</p>
                  </mat-card-title>
    
                  <mat-card-content>
                    <app-rating-selector
                      [preferredCategories]="convertRatingsToPreferredCategories(preferences.preferredRatings)"
                      (preferredCategoriesChange)="onPreferredCategoriesChanged($event)" forbiddenRatingsAlertType="error">
                    </app-rating-selector>
                  </mat-card-content>
                </mat-card>
  
                <mat-card class="no-border mb-0 pb-0 mb-sm-4 pb-sm-4">
                  <mat-card-title>
                    <p class="card-heading">Loan Tenure Preference</p>
                  </mat-card-title>
    
                  <mat-card-content class="pb-0 pb-lg-3 pb-xl-0">
                    <app-loan-tenure-selector
                      [investmentPreferences]="preferences.investmentAttrs"
                      (preferredLoanTenureChange)="onPreferredLoanTenureChanged($event)">
                    </app-loan-tenure-selector>
                  </mat-card-content>
                </mat-card>
  
                <mat-card class="no-border mb-4 mb-0 pb-0 mb-sm-4 pb-sm-4">
                  <mat-card-title>
                    <p class="card-heading">Maximum Loan Amount <span>*</span></p>
                  </mat-card-title>
    
                  <mat-card-content>
                    <app-max-loan-amount-selector
                      [investmentPreferences]="preferences.investmentAttrs"
                      (preferredMaxLoanAmountChange)="onPreferredMaxLoanAmountChanged($event)">
                    </app-max-loan-amount-selector>
                  </mat-card-content>
                </mat-card>
              </mat-card-content>
              <p class="mb-3 ml-4 note-text">Note: <span>*</span>Subject to a minimum of ₹ 1000</p>
            </mat-card>
          </div>
          <div>
            <h2 class="small-heading">Allocated Loans Email Notification</h2>
            <mat-card>
              <mat-card-title>
                <div class="row">
                  <p class="card-heading col-xs-9 col-sm-10">Email notification</p>
                  <div class="col-xs-3 col-sm-2">
                    <mat-slide-toggle [ngModel]="preferences?.allocatedLoanNotification"
                      aria-label="auto approve loan investment"
                      (change)="onAutoApproveLoanInvestmentChange($event.checked)" color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>
              </mat-card-title>
              <mat-card-subtitle>
                <div>
                  <p class="secondary-text">
                    <span *ngIf="!preferences?.allocatedLoanNotification">
                      You will not receive email notifications for new loans allocated to any of your investment
                      portfolios. The option to reverse any individual loan allocation (within the reversal expiry time
                      limit)
                      will continue to be available from the Allocated Loans listing on your dashboard.
                      If you wish to receive these email notifications, you can turn on this preference at any point.
                    </span>
                    <span *ngIf="preferences?.allocatedLoanNotification">
                      You will receive an email notification every time a new loan is allocated to one of your
                      investment portfolios. If you wish to stop receiving these emails, you can turn off this
                      preference at any point. The option to reverse any individual loan allocation
                      (within the reversal expiry time limit) will continue to be available from the Allocated
                      Loans listing on your dashboard.
                    </span>
                  </p>
                </div>
              </mat-card-subtitle>
            </mat-card>
          </div>
          <div *ngIf="!shouldShowDataLoader && configService.isFinzyBoltEnabled()">
            <h2 class="small-heading">finzyBolt</h2>
            <p class="preferences-description">
              Select the finzyBolt preferences below to automatically create portfolios from your wallet.
              <br><br>
              finzyBolt is a convenient feature allowing you to automatically invest your wallet funds
              into new loan(s) without any
              intervention from your end. Funds can be credited into the wallet from A. money that you
              transfer from your bank account, B.
              money sent to wallet during reinvestment or, C. money sent to wallet during a loan closure.
              <br><br>
              finzyBolt uses our proprietary <a [routerLink]="['/faq']" [queryParams]="{selectedTab: 'finzy_Pro'}"
                target="_blank">finzyPRO+</a> logic to automatically
              invest into loans on your behalf every time there is money in the wallet in excess of ₹1000.
              Read more about how finzyBolt works in our <a [routerLink]="['/faq']"
                [queryParams]="{selectedTab: 'finzy_Bolt'}" target="_blank">FAQs</a> section.
            </p>
            <mat-card>
              <mat-card-title>
                <div class="row">
                  <p class="card-heading col-xs-9 col-sm-10">finzyBolt</p>
                  <div class="col-xs-3 col-sm-2">
                    <mat-slide-toggle [ngModel]="preferences?.automaticInvestmentsFromWallet"
                      aria-label="finzyBolt preference"
                      (change)="onAutomaticInvestmentsFromWalletPreferenceChange($event.checked)" color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>
              </mat-card-title>
              <mat-card-subtitle>
                <div>
                  <p class="secondary-text">
                    <span *ngIf="!preferences?.automaticInvestmentsFromWallet">
                      finzyBolt is turned off. Please note, by switching on finzyBolt, the capability to create
                      portfolios yourself will not be available.
                    </span>
                    <span *ngIf="preferences?.automaticInvestmentsFromWallet">
                      finzyBolt is turned on. If you wish to transfer funds and create portfolios yourself, then you can
                      switch off
                      this preference at any point.
                    </span>
                  </p>
                </div>
              </mat-card-subtitle>
            </mat-card>
          </div>
          <div *ngIf="!shouldShowDataLoader">
            <h2 class="small-heading">Reinvest</h2>
            <p class="preferences-description">
              Select the reinvestment preferences below to allot and reinvest all or part of EMIs and
              prepayments that you receive, into new
              loans on the platform. Read more about how this works in our
              <a [routerLink]="['/faq']" [queryParams]="{selectedTab: 'reinvest'}" target="_blank">FAQs</a> section.
            </p>
            <p class="preferences-description">
              Please note, each time you reinvest in a new loan, the loan amount will be repaid as per the terms of the underlined loan or Investment Option.
            </p>
            <mat-card>
              <mat-card-title>
                <p class="card-heading">Reinvest my EMIs</p>
              </mat-card-title>
              <mat-card-subtitle>
                <p class="secondary-text">
                  Your monthly EMI contains Principal and Interest component. To reinvest your entire
                  EMI please choose to reinvest both
                  Principal and Interest component.
                </p>
              </mat-card-subtitle>
              <mat-card-content>
                <div class="row">
                  <div class="col-sm-6 col-xs-12">
                    <div class="col-xs-10">
                      <p>Principal component</p>
                      <p class="secondary-text">
                        <span *ngIf="!preferences?.reinvest?.emi?.reinvestPrincipal">
                          Principal component from your EMIs will be sent back to your registered bank account.
                        </span>
                        <span *ngIf="preferences?.reinvest?.emi?.reinvestPrincipal">
                          Principal component from your EMIs will be reinvested.
                        </span>
                      </p>
                    </div>
                    <div>
                      <mat-slide-toggle [ngModel]="preferences?.reinvest?.emi?.reinvestPrincipal"
                        aria-label="Reinvest Principal component of EMI"
                        (change)="onReinvestEMIPrincipalPreferenceChange($event.checked)" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="col-xs-10">
                      <p>Interest component</p>
                      <p class="secondary-text">
                        <span *ngIf="!preferences?.reinvest?.emi?.reinvestInterest">
                          Interest component from your EMIs will be sent back to your registered bank account.
                        </span>
                        <span *ngIf="preferences?.reinvest?.emi?.reinvestInterest">
                          Interest component from your EMIs will be reinvested.
                        </span>
                      </p>
                    </div>
                    <div>
                      <mat-slide-toggle [ngModel]="preferences?.reinvest?.emi?.reinvestInterest"
                        aria-label="Reinvest Interest component of EMI"
                        (change)="onReinvestEMIInterestPreferenceChange($event.checked)" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card>
              <mat-card-title>
                <p class="card-heading">Reinvest my Prepayments</p>
              </mat-card-title>
              <mat-card-subtitle>
                <p class="secondary-text">
                  At times, the borrower may choose to prerepay a part or the full amount of loan
                  outstanding. You can choose to allot and
                  reinvest such prepayments in new loans.
                </p>
              </mat-card-subtitle>
              <mat-card-content>
                <div class="row">
                  <div class="col-sm-6 col-xs-12">
                    <div class="col-xs-10">
                      <p>Entire Prepayment</p>
                      <p class="secondary-text">
                        <span *ngIf="preferences?.reinvest?.prepayment?.reinvestPrincipal">
                          All the prepayments you receive will be reinvested.
                        </span>
                        <span *ngIf="!preferences?.reinvest?.prepayment?.reinvestPrincipal">
                          All the prepayments will be sent back to your registered bank account.
                        </span>
                      </p>
                    </div>
                    <div>
                      <mat-slide-toggle [ngModel]="preferences?.reinvest?.prepayment?.reinvestPrincipal"
                        aria-label="Reinvest all components of Prepayment"
                        (change)="onReinvestPrepaymentPreferenceChange($event.checked)" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <div
              *ngIf="isShowSelectProductsToReinvest()">
              <mat-card>
                <mat-card-title>
                  <p class="card-heading">Reinvest my repayments in finzyFLEX or finzyPRO</p>
                </mat-card-title>
                <!-- <mat-card-subtitle>
                  <p class="secondary-text">
                    Your monthly EMI contains Principal and Interest component. To reinvest your entire
                    EMI please choose to reinvest both
                    Principal and Interest component.
                  </p>
                </mat-card-subtitle> -->
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <div class="col-xs-10">
                        <p>Reinvest in finzyFLEX</p>
                        <p class="secondary-text">
                          <span>
                            Choose your allocation percentage in finzyFLEX investment options and earn the returns accordingly. You also get an opportunity to withdraw  your investment post minimum holding period (MHP) 
                          </span>
                        </p>
                      </div>
                      <div>
                        <mat-slide-toggle [ngModel]="isFinzyFlexProductSelected"
                          aria-label="Reinvest in finzyFLEX"
                          (change)="onClickReinvestInFinzyFLEXProduct($event.checked)" color="primary">
                        </mat-slide-toggle>
                      </div>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                      <div class="col-xs-10">
                        <p>Reinvest in finzyPRO</p>
                        <p class="secondary-text">
                          <span>
                            Customize your risk preferences and earn returns accordingly.
                          </span>
                        </p>
                      </div>
                      <div>
                        <mat-slide-toggle [ngModel]="isFinzyProProductSelected"
                          aria-label="Reinvest in finzyPRO" (change)="onClickReinvestInFinzyPROProduct($event.checked)"
                          color="primary">
                        </mat-slide-toggle>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div *ngIf="isFinzyFlexProductSelected && (this.preferences.reinvest.emi.reinvestPrincipal || this.preferences.reinvest.emi.reinvestInterest || this.preferences.reinvest.prepayment.reinvestInterest || this.preferences.reinvest.prepayment.reinvestPrincipal)">
              <div *ngIf="isFinzyFlexProductSelected" class="mb-4">
                <app-flex-swift-attribute 
                  [userAttributesSwiftForm]="userAttributesSwiftForm"
                  [applicableProducts]="product.data"
                  [backUpUserAttributes]="backUpUserAttributes"
                  (userAttributesSwiftFormValue)="getUserAttributesSwiftFormValueOnChange($event)">
                </app-flex-swift-attribute>
              </div>
            </div>
            <!-- </div> -->




          </div>
        </div>
        <p *ngIf="preferences?.updatedAt" class="secondary-text">
          Your preferences were last updated on {{ preferences.updatedAt | date: 'medium' }}.
        </p>
        <div *ngIf="shouldShowDataLoader" class="spinner-section">
          <mat-spinner [diameter]="35" class="col-xs-offset-6"></mat-spinner>
        </div>

        <div class="row">
          <div class="col-xs-12 col-md-9">
            <p class="secondary-text text-justify">
              Note: As per RBI regulations, no lender should have more than ₹ 50 Lakhs principal
              outstanding across all P2P platforms in
              India including Finzy. You can change your preferences at any point in time to remain
              compliant.
            </p>
          </div>

          <div class="col-xs-12 col-md-3 text-right">
            <mat-spinner [diameter]="35" *ngIf="shouldShowSavingLoader || loader.spin === true"></mat-spinner>
            <button mat-flat-button class="primary" *ngIf="!shouldShowSavingLoader && loader.spin === false"
            [disabled]="shouldDisableSaveButton()" (click)="onSavePreferencesClicked(preferences)"
              >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>